import config from "../config";

// "preview" is the single HTML generation: it renders the on-screen preview and its blob is
// reused for the HTML download (the old "download" mode produced a byte-identical body, differing
// only by a Content-Disposition header we don't use). "download-print" is the separate PDF render.
export type ReportMode = "preview" | "download-print";

const nonSecure = /http:\/\//i;
const httpPrefix = /https{0,1}:\/\//i;
const portNumber = /:(\d+)(\/|$)/;
const portSection = /(:\d+)\/{0,1}/;
const graphqlSuffix = /\/graphql$/i;

export function getUrl() {
  const address = config.get("api.address");
  // allow manual prepending of http or https
  // add https for the httpLink if nothing was specified
  let baseAddress = "";
  let secure = true;
  if (nonSecure.test(address)) {
    secure = false;
  }
  const fallbackPort = secure ? 443 : 8347;
  // assume an fallbackPort if nothing was specified
  const port = address.match(portNumber)?.[1] ?? fallbackPort;
  baseAddress = address.replace(graphqlSuffix, "");
  baseAddress = baseAddress.replace(httpPrefix, "");
  baseAddress = baseAddress.replace(portSection, "");

  return {
    domain: baseAddress,
    fileUpload: ({ targetId, targetType }: { targetType: string; targetId?: string }) =>
      `http${secure ? "s" : ""}://${baseAddress}:${port}/upload/file/${[targetType, targetId].join("/")}`,
    fileUploadSetTarget: (targetId?: string) =>
      `http${secure ? "s" : ""}://${baseAddress}:${port}/upload/file/set-target-id/${targetId}`,
    fileDownload: (storageId: string) =>
      `http${secure ? "s" : ""}://${baseAddress}:${port}/upload/file/download/${storageId}`,
    http: `http${secure ? "s" : ""}://${baseAddress}:${port}/graphql`,
    ws: `ws${secure ? "s" : ""}://${baseAddress}:${port}/graphql`,
    report: ({ eventId, mode }: { eventId: string; mode: ReportMode }) => {
      const modePart = mode === "preview" ? "" : mode;
      const url = new URL(`http${secure ? "s" : ""}://${baseAddress}:${port}/reports/premade/${eventId}/${modePart}`);

      return url.toString();
    },
  };
}

export function getHttpUrl() {
  return getUrl().http;
}

export function getWsUrl() {
  return getUrl().ws;
}

export function getDomain() {
  return getUrl().domain;
}
